var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgPlus = function SvgPlus(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.999 0C43.453 0 56 12.547 56 28.001 56 43.453 43.453 56 27.999 56 12.547 56 0 43.453 0 28.001 0 12.547 12.547 0 27.999 0Zm-2.092 25.907h-9.803a2.101 2.101 0 0 0 0 4.2h9.803v9.803a2.101 2.101 0 0 0 4.2 0v-9.802h9.803a2.101 2.101 0 0 0 0-4.201h-9.802v-9.803a2.101 2.101 0 0 0-4.201 0v9.803Z"
  })));
};
export default SvgPlus;